import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { Provider } from "react-redux";
import { store, persistor } from "./reducers/store";
import { PersistGate } from "redux-persist/integration/react";
import { setupNetworkListeners } from "./reducers/courses/courseSlice";
import * as Sentry from "@sentry/react";
import "./polyfills";

// Initialize Sentry after imports
Sentry.init({
  dsn: "https://5dcf3f9d02ad8bed219c7ebc241a2a2e@o4509863948910592.ingest.de.sentry.io/4509864029323344",
  sendDefaultPii: true,
  integrations: [Sentry.browserTracingIntegration()],
  tracesSampleRate: 1.0,
  environment: process.env.NODE_ENV,
  release: "tredot-frontend@1.0.0",
});

setupNetworkListeners(store);

const LoadingComponent = () => (
  <div
    style={{
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      height: "100vh",
      fontSize: "18px",
    }}>
    Loading...
  </div>
);

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <Provider store={store}>
    <PersistGate loading={<LoadingComponent />} persistor={persistor}>
      <React.StrictMode>
        <Sentry.ErrorBoundary fallback={<p>Something went wrong</p>}>
          <App />
        </Sentry.ErrorBoundary>
      </React.StrictMode>
    </PersistGate>
  </Provider>
);

reportWebVitals();
